import axios from "axios";

// Replace these placeholders with your actual values
const ACCESS_TOKEN = "EAGYCy37jSn0BPGYsLwN5ytmfVHJ7ZAFhcgF1XEPZCiqZAz1racTtmbsv7iXXM1ZANeyF16nzTS1fydmlUT4ymQtPAEPIQ9wZBIwwahE77VbGq7KLmotcZBPVqjAEIcRZCioDhMPeKCWIrokscvkI5lHz94YC4uHkfZA9AiHOtuPWG2QQxQDmD9WIBocGbCjRK1BZA"; // Long-lived access token
const AD_ACCOUNT_ID = "1923530451430945"; // Your Ad Account ID
const BASE_URL = "https://graph.facebook.com/v22.0"; // Updated to v22.0
const CHUNK_DAYS = 20; // Number of days per batch
const EARLIEST_DATE = "2024-06-01"; // The earliest date to fetch data from

/**
 * Helper function to format a date as "YYYY-MM-DD".
 * 
 * 

 * 
 */
const formatDate = (date) => date.toISOString().split("T")[0];

/**
 * Fetch daily ad spend from Facebook Ads API in batches of 20 days,
 * starting from today and going backward until EARLIEST_DATE.
 * Save the aggregated data to sessionStorage and optionally update the table.
 */
export const fetchAndSaveFacebookAdSpend = async (updateTableData) => {
    try {
        const today = new Date();
        const earliestDate = new Date(EARLIEST_DATE);
        
        // Load existing data from sessionStorage
        const existingDataStr = sessionStorage.getItem("adsCosts");
        const existingData = existingDataStr ? JSON.parse(existingDataStr) : {};
        
        // Determine date range to fetch
        let fetchStartDate, fetchEndDate;
        
        // Always check if we have data from the earliest date and if we have gaps
        const existingDates = Object.keys(existingData).sort();
        const hasDataFromEarliest = existingData[EARLIEST_DATE] !== undefined;
        
        // Check for gaps in data by examining if we have continuous data from earliest date
        let hasGaps = false;
        if (existingDates.length > 0 && hasDataFromEarliest) {
            const firstExistingDate = new Date(existingDates[0]);
            const lastExistingDate = new Date(existingDates[existingDates.length - 1]);
            
            // Check if first date is after our earliest allowed date
            if (firstExistingDate > earliestDate) {
                hasGaps = true;
            }
        }
        
        if (Object.keys(existingData).length === 0 || !hasDataFromEarliest || hasGaps) {
            // No existing data OR missing data from earliest date OR has gaps - fetch everything from earliest date
            console.log("Fetching all data from", EARLIEST_DATE, "- Reason:", 
                Object.keys(existingData).length === 0 ? "No existing data" :
                !hasDataFromEarliest ? "Missing earliest date data" : "Data gaps detected");
            fetchStartDate = earliestDate;
            fetchEndDate = today;
        } else {
            // Find the latest date in existing data
            const latestExistingDate = new Date(existingDates[existingDates.length - 1]);
            
            // Start fetching from 3 days before the latest existing date to account for billing changes
            fetchStartDate = new Date(latestExistingDate);
            fetchStartDate.setDate(fetchStartDate.getDate() - 3);
            
            // Don't go earlier than our earliest allowed date
            if (fetchStartDate < earliestDate) {
                fetchStartDate = earliestDate;
            }
            
            fetchEndDate = today;
            
            console.log(`Existing complete data found up to ${formatDate(latestExistingDate)}. Fetching from ${formatDate(fetchStartDate)} to account for billing changes.`);
        }

        const newAdsCosts = {};
        let currentEndDate = fetchEndDate;

        // Loop until we reach the fetch start date
        while (currentEndDate >= fetchStartDate) {
            const currentStartDate = new Date(currentEndDate);
            currentStartDate.setDate(currentStartDate.getDate() - CHUNK_DAYS);

            // Ensure the start date does not go earlier than the fetch start date
            if (currentStartDate < fetchStartDate) {
                currentStartDate.setTime(fetchStartDate.getTime());
            }

            // API request for the current batch
            const url = `${BASE_URL}/act_${AD_ACCOUNT_ID}/insights`;
            const params = {
                access_token: ACCESS_TOKEN,
                time_range: JSON.stringify({
                    since: formatDate(currentStartDate),
                    until: formatDate(currentEndDate),
                }),
                fields: "date_start,spend", // Fields to retrieve
                level: "account", // Data level: ad, campaign, or account
                time_increment: 1, // Aggregate data daily
            };

            console.log(`Fetching data from ${formatDate(currentStartDate)} to ${formatDate(currentEndDate)}...`);

            try {
                const response = await axios.get(url, { params });
                const data = response.data.data;

                // Process and aggregate data
                data.forEach((entry) => {
                    newAdsCosts[entry.date_start] = parseFloat(entry.spend || 0);
                });
            } catch (batchError) {
                console.error(
                    `Error fetching data for ${formatDate(currentStartDate)} to ${formatDate(currentEndDate)}:`,
                    batchError.response?.data || batchError.message || batchError
                );
            }

            // Move the end date backward by CHUNK_DAYS
            currentEndDate.setDate(currentEndDate.getDate() - CHUNK_DAYS);
            
            // Break if we've reached the start date
            if (currentEndDate < fetchStartDate) {
                break;
            }
        }

        // Merge new data with existing data (new data overwrites existing for same dates)
        const mergedData = { ...existingData, ...newAdsCosts };
        
        // Save merged data to sessionStorage
        sessionStorage.setItem("adsCosts", JSON.stringify(mergedData));
        console.log(`Fetched ${Object.keys(newAdsCosts).length} new/updated entries. Total entries: ${Object.keys(mergedData).length}`);

        // Update table data if a callback is provided
        if (typeof updateTableData === "function") {
            updateTableData(mergedData);
        }
    } catch (error) {
        console.error(
            "Error during Facebook Ads data batching:",
            error.response?.data || error.message || error
        );
        throw error;
    }
};
